module.exports = __webpack_public_path__ + "media/icons/menu_small-e9f0645c.svg";